<template>
  <div class="batchrename-view">

    <!-- 软件落地页的子标题栏 -->
    <div class="soft-page-header-wrapper white-theme" id="soft-page-header">
      <div class="soft-page-header-content">
        <div class="soft-page-header-left">
          <div class="soft-page-header-left-gname">
            <img :src="szSoftIconUrl" alt="">
            <h1>{{szSoftName}}</h1>
          </div>
        </div>

        <div class="soft-page-header-right">
          <div class="soft-page-header-right-download">
            <a class="secondary-download-outer-btn" href="javascript:void(0)" @click.left="Util.DownloadButtonClicked(szSoftPackageUrl)">
              <img src="/images/softs/iconWin.svg" alt="">
              <span>立即下载</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="soft-page-content-wrapper">

      <div class="banner">
        <div class="banner-content">
          <div class="banner-left">
            <div class="banner-soft-tag">
              <span>{{iYEAR}}全新版</span>
            </div>

            <h2 class="banner-soft-name">{{szSoftName}}</h2>
            <p class="banner-soft-description">
              <img src="/images/softs/batchrename/iconGood.png">
              功能强大的文件名批量处理软件
            </p>
            <p class="banner-soft-feature">
              <img src="/images/softs/batchrename/iconBannerFeature-0.png">
              批量修改文件或文件夹名，支持导入Excel自定义规则
            </p>
            <p class="banner-soft-feature">
              <img src="/images/softs/batchrename/iconBannerFeature-1.png">
              一键提取文件或文件夹名，快速复制所有名称
            </p>
            <p class="banner-soft-feature">
              <img src="/images/softs/batchrename/iconBannerFeature-2.png">
              一键批量替换、删除、插入文件名部分字符
            </p>
            <p class="banner-soft-feature">
              <img src="/images/softs/batchrename/iconBannerFeature-3.png">
              批量修改文件或文件夹时间
            </p>

            <div class="banner-soft-download">
              <a class="banner-soft-download-btn" href="javascript:void(0)" @click.left="Util.DownloadButtonClicked(szSoftPackageUrl)">
                <img src="/images/softs/iconWinForBanner.svg" alt="">
                免费下载
              </a>
            </div>

            <p class="banner-soft-supported-sys"><span>适用系统：win7/win8/win10/win11</span></p>
            <p class="banner-soft-update-date"><span>更新时间：{{szSoftUpdateDate}}</span></p>
          </div>

          <div class="banner-right">
            <img src="/images/softs/batchrename/iconBannerProduct.png" alt="">
          </div>
        </div>

        <div class="banner-bottom">
          <!-- 使用 #toLocaleString('en-US')，让整型部分每3位一个逗号 -->
          <p><img src="/images/softs/batchrename/iconFakeCount.png"/> 下载用户：<span>{{iFakeUserCount.toLocaleString('en-US')}}</span></p>
          <p><img src="/images/softs/batchrename/iconFakeCount.png"/> 累积修改文件：<span>{{iFakeFileCount.toLocaleString('en-US')}}</span></p>
        </div>
      </div>

      <!-- 功能介绍 -->
      <div class="feature-wrapper">
        <h3>功能介绍</h3>
        <ul>
          <li>
            <img src="/images/softs/batchrename/iconFeature-0.png" alt="">
            <h2>一键修改</h2>
            <p>支持自定义/替换/插入等多种方式一键修改文件名，自定义扩展名，轻松修改文件名和文件类型</p>
          </li>
          <li>
            <img src="/images/softs/batchrename/iconFeature-1.png" alt="">
            <h2>批量重命名</h2>
            <p class="test">添加文件类型不限，一键对所有文件进行重命名</p>
          </li>
          <li>
            <img src="/images/softs/batchrename/iconFeature-2.png" alt="">
            <h2>实时预览</h2>
            <p>文件列表实时预览新文件名，确保命名准确</p>
          </li>
        </ul>
        <ul class="feature-ul2">
          <li>
            <img src="/images/softs/batchrename/iconFeature-3.png" alt="">
            <h2>编号设置</h2>
            <p>支持添加字母和数字编号，轻松排序整理多个文件</p>
          </li>
          <li>
            <img src="/images/softs/batchrename/iconFeature-4.png" alt="">
            <h2>导入名称命名</h2>
            <p>将填有文件名的Excel表格导入，一键将文件批量重命名成指定文本</p>
          </li>
          <li>
            <img src="/images/softs/batchrename/iconFeature-5.png" alt="">
            <h2>文件时间属性修改</h2>
            <p>支持修改文件“创建时间”及“修改时间”，一键批量修改，便捷高效</p>
          </li>
        </ul>
      </div>

      <div class="use-steps-wrapper">
        <div class="use-steps-wrapper-content">
          <div class="step-content-item">
            <h3>三步实现文件重命名</h3>
            <div class="step-detail-box">
              <div class="step-detail">
                <img src="/images/softs/batchrename/stepNumberPoint.png" alt="">
                <ul>
                  <li>
                    <h2>添加需要重命名的文件</h2>
                    <img src="/images/softs/batchrename/stepNumber-0.png" alt="">
                    <p>通过点击 &lt;添加按钮&gt; 或拖拽指定文件至文件列表中</p>
                  </li>
                  <li>
                    <h2>在工作台对文件名进行设置<img src="/images/softs/batchrename/stepNumber-1.png" alt=""></h2>
                    <p>在工作台对文件名、扩展名、编号、大小写等进行一键设置，或导入Excel表格一键批量设置</p>
                  </li>
                  <li>
                    <h2>一键修改文件名<img src="/images/softs/batchrename/stepNumber-2.png" alt=""></h2>
                    <p>点击 &lt;开始命名&gt; 按钮，对文件列表的文件批量重命名</p>
                  </li>
                </ul>
              </div>
              <div class="use-steps-item-imgs">
                <img class="use-steps-item-img" src="/images/softs/batchrename/stepImg.png" alt="">
              </div>
              <img class="step-ornament" src="/images/softs/batchrename/bgStepOrnament.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-download-wrapper">
        <h1>摆脱繁琐手动重命名，一键批量重命名超轻松</h1>
        <a href="javascript:void(0)" @click.left="Util.DownloadButtonClicked(szSoftPackageUrl)">
          <img src="/images/softs/iconWinForBanner.svg" alt="">
          免费下载
        </a>
      </div>

      <!-- 用户给我们的评价 -->
      <div class="user-quotes-wrapper">
        <div class="user-quotes-content">
          <ul>
            <template v-for="(item, idx) in stUserQuotes">
              <li v-show="iCurUserQuoteIdx == idx">
                <div class="user-quotes-star">
                  <h1>{{szSoftName}}</h1>
                  <img src="/images/softs/batchrename/commentStars.png" alt="">
                </div>

                <span></span>  <!-- 用于作为分割线 -->

                <p>{{item.text}}</p>

                <!-- 菱形，用于作为对话框露出来的小三角 -->
                <i :style="`left: ${idx * 200 + 75}px`"></i>
              </li>
            </template>
          </ul>
          <ul>
            <template v-for="(item, idx) in stUserQuotes">
              <li @mouseenter="EnterUserQuoteItemHead($event, idx)" @mouseleave="LeaveUserQuoteItemHead($event, idx)">
                <img :src="item.userHeaderUrl" alt="">
                <img v-show="iCurUserQuoteIdx == idx" src="/images/softs/batchrename/bgUserQuoteItemActiveHead.png" alt="">
                <p>{{item.userName}}</p>
              </li>
            </template>
          </ul>
          <!-- 用于遮住菱形上面部分，形成对话框露出来的小三角 -->
          <div class="user-quotes-content-triangle-mask"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
.batchrename-view {
  margin: 0 auto;
  background-color: #fff;
}

.soft-page-content-wrapper {
  margin-top: 59px;
}

.banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
  padding-bottom: 74px;
  background: url(/images/softs/batchrename/bgStep.png) no-repeat center;
  background-size: cover;

  .banner-content {
    transform: translateX(5%);

    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1280px;
    margin: 0 auto;
  }

  .banner-left {
    display: flex;
    flex-direction: column;

    .banner-soft-tag {
      background: url(/images/softs/batchrename/bgBannerSoftTag.png) no-repeat;
      width: 132px;
      height: 103px;
      display: flex;
      justify-content: center;

      transform: translateX(230%) translateY(20%);

      span {
        margin-top: 38px;
        color: #fff;
        font-size: 17px;
        font-weight: 700;
      }
    }

    .banner-soft-name {
      color: #1D2129;
      font-family: "Microsoft YaHei UI";
      font-size: 58px;
      font-weight: 700;
      line-height: 70px;
    }

    .banner-soft-description {
      margin: 28px 0 41px 0;
      color: #19D0B2;
      font-family: "inter";
      font-size: 20px;

      display: flex;
      align-items: center;

      img {
        width: 40px;
        margin-right: 10px;
      }
    }

    .banner-soft-feature {
      display: flex;
      align-items: center;

      margin-top: 9px;
      img {
        width: 42px;
        margin-right: 13px;
      }
    }

    .banner-soft-download {
      margin-top: 48px;

      .banner-soft-download-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 220px;
        height: 60px;

        cursor: pointer;
        border-radius: 10px;
        background: #19D0B2;
        color: #FFF;
        text-align: center;
        font-size: 20px;

        &:hover {
          background: linear-gradient(270deg, #19D0B2 0%, #49DAB6 100%);
        }

        img {
          margin-right: 16px;
        }
      }
    }

    .banner-soft-supported-sys {
      margin-top: 16px;
      font-size: 14px;
      color: #737373;
    }
    .banner-soft-update-date {
      margin-top: 5px;
      font-size: 14px;
      color: #737373;
    }
  }

  .banner-right {
    margin-left: -80px;
  }

  .banner-bottom {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    /* width: 415px; */
    margin-top: 76px;

    p {
      color: #595959;
      font-family: 'Inter';
      font-size: 25px;
      line-height: 100%; /* 18px */
      letter-spacing: 0.36px;

      display: flex;
      align-items: center;

      span {
        color: #19D0B2;
        font-family: 'Inter';
        font-size: 35px;
        font-weight: 500;
        line-height: 100%;
        letter-spacing: 0.54px;
      }
    }
    p:nth-child(1) {
      margin-right: 121px;
    }

    img {
      width: 43px;
      margin-right: 8px;
    }
  }

  .banner-bottom-content {
    display: flex;
    flex-direction: column;
    gap: 8px;

    span:first-of-type {
      color: #333;
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
    }

    span:last-of-type {
      color: #19D0B2;
      font-size: 18px;
      line-height: 20px;
    }
  }
}

.feature-wrapper {
  padding: 100px 0px 0px 0px;
  h3 {
    font-family: 'Microsoft YaHei UI';
    font-weight: 700;
    font-size: 36px;
    line-height: 46px;
    text-align: center;
    color: #273446;

    margin-bottom: 82px;
  }

  ul {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;

    li {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        height: 70px;
      }

      h2 {
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        color: #3A3A3A;
        margin-top: 30px;
        margin-bottom: 16px;
      }

      p {
        width: 291px;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        color: #3A3A3A;
        opacity: 0.8;
      }

      p.test {
        width: 294px;
      }
    }
  }

  ul.feature-ul2 {
    margin-top: 77px;
  }
}

.use-steps-wrapper {
  position: relative;
  width: 100%;
  min-height: 864px;

  background: url(/images/softs/batchrename/bgStep.png) no-repeat center;
  background-size: cover;
}

.use-steps-wrapper-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 1270px;
  margin: 0 auto;

  h3 {
    font-weight: 700;
    font-size: 48px;
    line-height: 63px;
    letter-spacing: 0.05em;
    color: #3A3A3A;
  }
}

.step-detail-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 100px;

  .step-detail {
    position: relative;
    display: flex;
    align-items: center;
    width: 500px;

    ul {
      li {
        position: absolute;
        left: 48px;
        z-index: 2;

        h2 {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: max-content;
          font-size: 32px;
          line-height: 42px;
          letter-spacing: 0.05em;
          color: #484848;
          margin-bottom: 20px;
        }

        p {
          margin-top: 58px;
          color: #727272;
        }
      }

      li:nth-child(1) {
        top: -10px;
        img {
          position: absolute;
          left: -37px;
          top: -46px;
          z-index: 1;
        }
      }

      li:nth-child(2) {
        top: 182px;
        img {
          position: absolute;
          left: -33px;
          top: -47px;
          z-index: 1;
        }
      }

      li:nth-child(3) {
        top: 373px;
        img {
          position: absolute;
          left: -34px;
          top: -51px;
          z-index: 1;
        }
      }
    }
  }

  .step-ornament {
    position: absolute;
    right: -204px;
    top: -255px;
    z-index: 1;
  }
}


.use-steps-item-img {
  position: absolute;
  right: -166px;
  top: -125px;
  z-index: 2;
  width: 842px;
}

.bottom-download-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 70px 0;
  box-sizing: border-box;
  background: url(/images/softs/batchrename/bgBottomDownload.png) no-repeat center/cover;

  h1 {
    color: #3c3c3c;
    text-align: center;
    font-family: 'Source Han Sans CN';
    font-size: 38px;
    font-weight: 700;
    line-height: 100%; /* 38px */
    letter-spacing: 0.76px;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    padding: 13px 47px;
    box-sizing: border-box;
    color: #fff;
    font-family: Microsoft YaHei;
    font-size: 20px;
    line-height: 100%; /* 20px */
    border-radius: 10px;
    background-color: #19d0b2;

    img {
      margin-right: 16px;
      width: 30px;
    }
  }
}

.user-quotes-wrapper {
  background: linear-gradient(90deg, #f4f6f8 0%, #fff 154.92%);
  width: 100%;
  padding-bottom: 110px;
  box-sizing: border-box;

  .user-quotes-content {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    padding-top: 120px;

    ul:nth-child(1) {
      li {
        width: 100%;
        height: 307px;
        box-sizing: border-box;
        border-radius: 30px;
        background: #ffffff;
        position: relative;
        z-index: 1;
        text-align: center;
        padding-top: 48px;
        border-radius: 30px;
        border: 2px solid transparent;
        fill: #fff;
        filter: drop-shadow(0px 0px 14px rgba(186, 186, 186, 0.25));

        span {
          display: block;
          width: 100%;
          height: 1px;
          background: #2f3458;
          border-radius: 0px 0px 0px 0px;
          margin: 40px auto 0 auto;
          opacity: 0.15;
          background: #b1b1b1;
        }

        p {
          color: #555;
          text-align: center;
          font-family: Microsoft YaHei UI;
          font-size: 18px;
          line-height: 30px; /* 166.667% */
          text-transform: lowercase;
          margin-top: 44px;
        }

        i {
          width: 40px;
          height: 40px;
          background: #fff;
          border-radius: 2px 2px 2px 2px;
          transform: rotate(45deg);
          position: absolute;
          bottom: -20px;
          border: 2px solid #fff;
          border-radius: 7px;
        }

        .user-quotes-star {
          h1 {
            margin-bottom: 24px;
            color: #111;
            font-family: Microsoft YaHei UI;
            font-size: 26px;
            font-weight: 700;
            line-height: normal;
          }
        }
      }
    }

    .user-quotes-content-triangle-mask {
      position: absolute;
      top: 396px;
      left: 26px;
      width: 1147px;
      height: 30px;
      background-color: #fff;
      z-index: 1;
    }

    ul:nth-child(2) {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 63px;

      li:hover {
        cursor: pointer;
        border: 3px solid transparent;
      }

      li {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 3px solid transparent;

        img {
          margin-top: 2.5px;
          width: 76px;
          height: 76px;
        }
        img:nth-child(2) {
          position: absolute;
          top: -7px;
          left: -4.8px;
          width: 90px;
          height: 90px;
        }

        p {
          display: inline-block;
          width: 96px;
          color: #555;
          text-align: center;
          font-family: Microsoft YaHei UI;
          font-size: 16px;
          line-height: 30px; /* 187.5% */
          text-transform: lowercase;
          margin-top: 17px;
          margin-bottom: 11px;
        }

        h2 {
          color: #555;
          text-align: center;
          font-family: Microsoft YaHei UI;
          font-size: 16px;
          line-height: 30px; /* 187.5% */
          text-transform: lowercase;
        }
      }
    }
  }
}
</style>

<script lang="ts" setup>
/* definePageMeta()是编译器宏，不用实际代码运行 */
definePageMeta({
})

import * as Vue from 'vue'
import * as VueUse from '@vueuse/core'
import * as Util from '@/util'

const iYEAR = new Date().getFullYear()
const szSoftUpdateDate = (() => {
  /* 当前日期减去15天 */
  const now = Date.now();
  const sevenDaysAgo = now - (15 * 24 * 60 * 60 * 1000);
  const date = new Date(sevenDaysAgo);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
})()

/* 虚假的累计下载数、修改文件数 */
let iFakeUserCount = Vue.ref(Math.floor((new Date().getTime() - 1631865935991) / 10000))
let iFakeFileCount = Vue.ref(Math.floor((new Date().getTime() - 1539942786413) / 10000))

const szSoftName = '易趣批量重命名'
const szSoftIconUrl = '/images/softs/batchrename/appLogo.png'

const szSoftPackageUrl = 'https://gitcode.com/qq_43479262/YQBatchRename-package/releases/download/v1.1.1/YQBatchRenameMinIns_1.1.1.0_001.exe'

let iCurUserQuoteIdx = Vue.ref(0)
let iUserQuoteTimerId = 0
const stUserQuotes = Vue.ref([
  {
    userHeaderUrl: '/images/softs/batchrename/head1.png',
    userName: '书山鸭梨大',
    text: '我是个喜欢分类的强迫症，用过好几种批量重命名的工具，还是这个最友好，十分满意了，希望以后越来越强大。',
  },
  {
    userHeaderUrl: '/images/softs/batchrename/head2.png',
    userName: '晚安到天亮',
    text: '感觉软件做得很用心，除了能够批量重命名，还可以直接改掉后缀名，能够解决的问题不止一两个，用得十分顺手。',
  },
  {
    userHeaderUrl: '/images/softs/batchrename/head3.png',
    userName: '斯堪的白熊',
    text: '系统类工具用得还是挺少的，但这个真心不错，深得我心。换电脑了，我还是会继续使用滴，给个赞！',
  },
  {
    userHeaderUrl: '/images/softs/batchrename/head4.png',
    userName: 'Nicole',
    text: '我是用来整理照片的，用它修改后的文件名看上去太整洁了。试过很多软件，这个设计比较简洁，希望开发者越做越好！',
  },
  {
    userHeaderUrl: '/images/softs/batchrename/head5.png',
    userName: '吹空调的cat',
    text: '本人从事文职岗位的，每天就面临着巨多的Excel表格文件要整理，这款重命名工具真的帮到我了，顶上去！',
  },
  {
    userHeaderUrl: '/images/softs/batchrename/head6.png',
    userName: '高贵的小桂圆',
    text: '文件多了，还真的得借助这类型的软件。比起乱糟糟的文件名，有规律的文件看上去心情都不一样，不错不错。',
  },
])

/* 用于动态设置当前页面的标题 */
useHead({
  title: szSoftName + '-支持windows所有文件格式-免费使用',
  link: [
    { rel: 'icon', href: szSoftIconUrl }
  ],
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
    { name: 'description', content: szSoftName + '是一款文件批量改名工具，功能简洁、操作简便、侧重实用，可通过鼠标点击轻松完成添加文件、设定规则、批量改名的操作，并且支持windows所有文件格式，让文件批量重命名更简单' },
    { name: 'keywords', content: szSoftName + ',文件批量重命名,文件重命名,多文件重命名,重命名,免费软件' },
  ],
})

Vue.onMounted(() => {
  /* 动态设置当前页面的图标，参考：https://stackoverflow.com/questions/77135452/how-to-change-the-favicon-dynamically-in-nuxt-3 */
  /* 对于Nuxt项目，可以使用useHead()，但是好像对于图标来说，只能支持svg? */
  /*   这里使用VueUse.useFavicon设置png */
  VueUse.useFavicon(szSoftIconUrl, {
    rel: 'icon'
  })

  /* 开启定时更新用户评价的定时器 */
  iUserQuoteTimerId = setInterval(ChangeToNextUserQuote, 3000)
})

function ChangeToNextUserQuote()
{ iCurUserQuoteIdx.value = (iCurUserQuoteIdx.value + 1) % stUserQuotes.value.length }
function EnterUserQuoteItemHead(evt: MouseEvent, idx: number)
{
  clearInterval(iUserQuoteTimerId)
  iUserQuoteTimerId = 0
  iCurUserQuoteIdx.value = idx
}
function LeaveUserQuoteItemHead(evt: MouseEvent, idx: number)
{ iUserQuoteTimerId = setInterval(ChangeToNextUserQuote, 3000) }
</script>
